import * as PhaseTypeActionType from './constants';

const defaultParams = {
  name: '',
  skip: 1,
  take: 10,
  sort: { field: 'name', order: 'ascending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const PhaseProfile = {
  id: '',
  projectId: '',
  name: '',
  startDate: null
};

const ManagePhases = {
  items: [],
  params: defaultParams
};

const PhaseState = {
  ManagePhases: ManagePhases,
  PhaseProfile: PhaseProfile,
  ErrorMsg: [],
  dateTime: new Date(),
  IsSuccessStep2: false,
  IsOpenFormEdit: false,
  SelectListPhase: []
};

export default function PhaseStore(state = PhaseState, action) {
  switch (action.type) {
    case PhaseTypeActionType.SEARCH_PHASE_SUCCESS:
      return processSearchSuccess(state, action);
    case PhaseTypeActionType.CREATE_UPDATE_PHASE_ERROR:
      return {
        ...state,
        ErrorMsg: [action.data.error],
        PhaseProfile: {
          ...state.PhaseProfile,
          name: action.data.params.name
        },
        IsOpenFormEdit: action.data.isEdit
      };
    case PhaseTypeActionType.GET_PHASE_BY_ID_SUCCESS:
      return processGetByIdSuccess(state, action);
    case PhaseTypeActionType.RESET_PHASE:
      return {
        ...state,
        ManagePhases: ManagePhases,
        ErrorMsg: [],
        dateTime: new Date(),
        IsSuccessStep2: false,
        IsOpenFormEdit: false
      };
    case PhaseTypeActionType.GET_LIST_PHASE_BY_PROJECT_SUCCESS:
      return {
        ...state,
        SelectListPhase: action.data
      };
    case PhaseTypeActionType.UPDATE_PHASE_SUCCESS:
      return {
        ...state,
        PhaseProfile: action.data,
        ErrorMsg: []
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var managePhases = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      status: result.params.status,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };
  return {
    ...state,
    ManagePhases: managePhases,
    ErrorMsg: [],
    IsOpenFormEdit: false
  };
};

const processGetByIdSuccess = (state, action) => {

  return {
    ...state,
    PhaseProfile: action.data,
    ErrorMsg: [],
    IsOpenFormEdit: true
  };
};



// WEBPACK FOOTER //
// ./src/Projects/phase-reducers.js